const RESERVED_NAMES = ['pushbot', 'admin', 'owner', 'public', 'me'];
const RESERVED_NAME_PATTERN = new RegExp(
  `^(${RESERVED_NAMES.join('|')})$`,
  'i'
);
const USERNAME_PATTERN = /^[a-z0-9_]+$/;
const FIRST_LETTER_PATTERN = /^[a-z]+$/;

export const isReservedName = value => RESERVED_NAME_PATTERN.test(value);

export const isAlphanumeric = value => {
  return USERNAME_PATTERN.test(value);
};

export const isFirstLetter = value => {
  return FIRST_LETTER_PATTERN.test(value);
};
